<template>
  <b-avatar
  :src="image"
  :size="size"
  :button="true"
  v-if="!loading && image"
  :text="initials"
  v-b-popover.hover.top="user.name"
  :badge="badge"
  :badge-variant="badgeColor"
  @click="$emit('click', user)"></b-avatar>
</template>

<script>
import moment from 'moment-timezone'
import Api from '@/api/Api'

export default {
  props: [ 'user', 'size' ],
  data () {
    return {
      loading: true,
      image: null
    }
  },
  created () {
    var vm = this
    vm.loading = true
    Api().get(`User/${vm.user.id}/Image/`)
      .then((r) => {
        vm.image = 'data:' + r.data.contentType + ';base64,' + r.data.content
      })
      .catch((e) => {
        console.log(e)
      })
      .finally(() => {
        vm.loading = false
      })
  },
  methods: {
    showDetails () {
      console.log('clicked')
      this.$bvModal.msgBoxOk(this.user.email, {
        title: this.user.name,
        buttonSize: 'sm',
        centered: true,
        size: 'sm'
      })
    }
  },
  computed: {
    initials () {
      var initials = this.user.name.match(/\b\w/g) || []
      return ((initials.shift() || '') + (initials.pop() || '')).toUpperCase()
    },
    badgeColor () {
      var loginTime = moment(this.user.lastLogin).local()
      if (moment().subtract(1, 'years') > loginTime) {
        return 'danger'
      }
      if (moment().subtract(6, 'hours') > loginTime) {
        return 'warning'
      }
      return 'success'
    },
    badge () {
      var loginTime = moment(this.user.lastLogin).local()
      if (moment().subtract(1, 'years') > loginTime) {
        return 'X'
      }
      return ''
    }
  }
}
</script>

<style>

</style>
